/**
 * @generated SignedSource<<9cf852b4b971e302d39a9447115124c9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PaymentConfirmedTaskInput = {
  hasAcknowledgedInformation?: boolean | null;
  masterSalesChannelID?: string | null;
  secondarySalesChannelID?: string | null;
  shopifyChargeID?: string | null;
};
export type salesChannelCreatePaymentConfirmedTaskMutation$variables = {
  input: PaymentConfirmedTaskInput;
};
export type salesChannelCreatePaymentConfirmedTaskMutation$data = {
  readonly generatePaymentConfirmedTask: {
    readonly taskID: number;
  } | null;
};
export type salesChannelCreatePaymentConfirmedTaskMutation = {
  response: salesChannelCreatePaymentConfirmedTaskMutation$data;
  variables: salesChannelCreatePaymentConfirmedTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProductSwitcherTaskOutput",
    "kind": "LinkedField",
    "name": "generatePaymentConfirmedTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelCreatePaymentConfirmedTaskMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelCreatePaymentConfirmedTaskMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "780cd5781d33987b6260f71b48f5d790",
    "id": null,
    "metadata": {},
    "name": "salesChannelCreatePaymentConfirmedTaskMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelCreatePaymentConfirmedTaskMutation(\n  $input: PaymentConfirmedTaskInput!\n) {\n  generatePaymentConfirmedTask(input: $input) {\n    taskID\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d76f51026289753eb33843d2085d538";

export default node;
